var _defs, _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1456.49 1456.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fed631;}.cls-2{fill:#1a1a1a;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 149.67,
    y: 149.67,
    width: 1157.15,
    height: 1157.15,
    rx: 133.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1086.83,497c.42,35.85-29.29,63.51-68.44,63.72-39.89.19-67.13-25.65-67.21-63.8s26.92-64.43,66.57-64.74C1056.9,431.87,1086.39,459.55,1086.83,497Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1082.55,1008.39c.14,13-4.14,16.2-16.43,15.92-33.41-.76-66.85-.49-100.27-.13-8.67.11-12.07-2.26-12.05-11.55q.38-194.36,0-388.74c0-9.48,2.93-12.91,12.58-12.79,33.89.45,67.77.63,101.65,0,11.92-.23,14.55,4.6,14.49,15.41-.37,64.1-.18,128.21-.18,192.31h-.08C1082.26,882,1081.9,945.21,1082.55,1008.39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M883.59,1012.63Q865.1,952.3,846.49,892,780.19,678.39,714,464.77c-2.53-8.22-6.92-9.07-13.95-9-48.11.2-96.23.41-144.33-.12-10-.11-14.35,2.89-17.21,12.54-18.47,62.26-37.45,124.37-56.5,186.46q-49.68,162-99.61,323.95c-4.38,14.26-8.26,28.68-12.78,44.42H501.54c1.33-4.13,2.87-8.43,4.1-12.81,11.14-39.63,22.68-79.16,33-119,2.85-10.94,8.15-13,18.26-12.93,43.52.48,87.07.89,130.58-.17,14.1-.35,19.93,4.07,23.57,17.42,10.7,39.26,22.57,78.21,34.65,117.06,1.41,4.52,7,10.94,10.8,11,42.51.78,85.05.49,129.77.49C885,1018.63,884.49,1015.58,883.59,1012.63ZM562.34,781l59.49-226.8C643,629.6,664.08,704.64,685.53,781Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIll);
export default __webpack_public_path__ + "static/media/ill.05ea63c9019fd021de286de823d94847.svg";
export { ForwardRef as ReactComponent };